module.exports = __webpack_public_path__ + "img/a6ed79a.png";